import { mainApi } from "@/services/api/main-api";

export const loginApi = mainApi
    .injectEndpoints({
        endpoints: (builder: any) => ({
            login: builder.mutation({
                query: (
                    data: any) => ({
                    url: `/public/admin-user/login`,
                    method: "POST",
                    body: data,
                }),
            }),
        }),
    });

export const {
    useLoginMutation
} = loginApi;

export default loginApi;
